<template>
  <div class="color-picker">
    <div class="top">
      <h3>
        {{ title }}
      </h3>
      <div class="picker-wrap">
        <span> Select color </span>
        <input
          type="color"
          :value="value"
          @input="$emit('input', $event.target.value)"
        />
      </div>
    </div>
    <div class="bottom">
      {{ label }}
    </div>
  </div>
</template>

<script>
export default {
  props: {
    title: {
      type: String,
    },
    label: {
      type: String,
    },
    value: {
      type: String,
    },
  },
};
</script>

<style lang='scss' scoped>
.color-picker {
  margin: 25px 0 50px 0;
  .top {
    display: flex;
    align-items: center;
    justify-content: space-between;
    h3 {
      margin: 0;
      font-family: Roboto;
      font-style: normal;
      font-weight: 500;
      font-size: 16px;
      color: #001529;
    }
    .picker-wrap {
      border:1px solid #cbcbe4;
      display: flex;
      align-items: center;
      justify-content: center;
      padding: 0;
      span {
        display: flex;
        align-items: center;
        justify-content: center;
        height: 31px;
        border-radius: 2px 0px 0px 2px;
        padding: 1px 5px;
        font-family: Roboto;
        font-style: normal;
        font-weight: normal;
        font-size: 14px;
        line-height: 22px;
        color: #001529;
      }
      input {
        width: 38px;
        height: 38px;
        padding: 0;
        border-radius: 0;
        background: none;
        border: none;
        outline: none;
        cursor: pointer;
      }
    }
  }
  .bottom {
    font-family: Roboto;
    font-style: normal;
    font-weight: normal;
    font-size: 14px;
    line-height: 16px;
    color: #001529;
  }
}
</style>
